import axios from "axios";
import axiosBaseUrl from "./axsios";
import Cookies from 'js-cookie';
import Api from './ApiUrl'
const API_URL = `${Api}/api/v1/items`;



export const DeleteData = async (url) => {
  const config = {
    headers: {Authorization: `Bearer ${Cookies.get('token')}`},
  };
  const res = await axiosBaseUrl.delete(url, config);
  return res;
};

export const GetData = async (url) => {
    const res = await axiosBaseUrl.get(url);
    return res.data;
  };




  
  export const useGetDataProtected = async (url) => {
    const token = localStorage.getItem("token");
    const config = {
      headers: {Authorization: `Bearer ${token}`},
    };
    const res = await axiosBaseUrl.get(url, config);
    return res.data;
  };








  export const PostData = async (url, data) => {
    // const config = {
    //   headers: {
    //     Authorization: `Bearer ${Cookies.get('token')}`,
    //   },
    // };
    const res = await axiosBaseUrl.post(url, data);
    return res;
  };
  export const PostDatalogin = async (url, data) => {
    const config = {
      headers: {
        Authorization: `Bearer ${Cookies.get('token')}`,
      },
    };
  
    try {
      const res = await axiosBaseUrl.post(url, data, config);
      return res;
    } catch (error) {
      console.error('Error:', error);
      return error; // Rethrow the error to propagate it to the calling code
    }
  };
  



  export const PostDataWithImg = async (API_URL, data,onUploadProgress) => {
    // const config = {
    //   headers: {
    //     "Content-Type": "multipart/form-data",
    //     Authorization: `Bearer ${Cookies.get('token')}`,
    //   },
    //   onUploadProgress,
    // };
    const res = await axios.post(`${Api}/api/v1/items`, data);
    return res;
  };
    






  export const useUpdateData = async (url, data) => {
    const config = {
      headers: {Authorization: `Bearer ${Cookies.get('token')}`},
    };
    const res = await axiosBaseUrl.put(url, data, config);
    return res;
  };
  
  export const UpdateDataWithImg = async (url, data,onUploadProgress) => {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${Cookies.get('token')}`,
      },
      
      onUploadProgress
    };
    const res = await axiosBaseUrl.put(url, data, config);
    return res;
  };
  

  export const UpdateEmail = async (url) => {

    const res = await axiosBaseUrl.patch(url);
    return res;
  };
  





// import axiosBaseUrl from "./axios";
// import Cookies from 'js-cookie';
// import { toast } from 'react-toastify';

// const getTokenConfig = () => ({
//   headers: {
//     Authorization: `Bearer ${Cookies.get('token')}`
//   }
// });

// const handleErrors = (error) => {
//   if (error.response && error.response.data) {
//     const { errors, message } = error.response.data;
//     if (Array.isArray(errors)) {
//       errors.forEach(err => toast.error(err.msg));
//     } else {
//       toast.error(message || "An error occurred");
//     }
//   } else {
//     toast.error("Network error");
//   }
//   throw error;
// };

// export const DeleteData = async (url) => {
//   const confirm = window.confirm("Are you sure you want to delete?");
//   if (!confirm) return;
//   try {
//     const res = await axiosBaseUrl.delete(url, getTokenConfig());
//     toast.success("Deleted successfully");
//     return res;
//   } catch (error) {
//     handleErrors(error);
//   }
// };

// export const GetData = async (url) => {
//   try {
//     const res = await axiosBaseUrl.get(url);
//     return res.data;
//   } catch (error) {
//     handleErrors(error);
//   }
// };

// export const useGetDataProtected = async (url) => {
//   try {
//     const res = await axiosBaseUrl.get(url, getTokenConfig());
//     return res.data;
//   } catch (error) {
//     handleErrors(error);
//   }
// };

// export const PostData = async (url, data) => {
//   try {
//     const res = await axiosBaseUrl.post(url, data, getTokenConfig());
//     toast.success("Created successfully");
//     return res;
//   } catch (error) {
//     handleErrors(error);
//   }
// };

// export const PostDataWithImg = async (url, data, onUploadProgress) => {
//   const config = {
//     headers: {
//       "Content-Type": "multipart/form-data",
//       ...getTokenConfig().headers
//     },
//     onUploadProgress
//   };
//   try {
//     const res = await axiosBaseUrl.post(url, data, config);
//     toast.success("Created successfully");
//     return res;
//   } catch (error) {
//     handleErrors(error);
//   }
// };

// export const useUpdateData = async (url, data) => {
//   try {
//     const res = await axiosBaseUrl.put(url, data, getTokenConfig());
//     toast.success("Updated successfully");
//     return res;
//   } catch (error) {
//     handleErrors(error);
//   }
// };

// export const UpdateDataWithImg = async (url, data, onUploadProgress) => {
//   const config = {
//     headers: {
//       "Content-Type": "multipart/form-data",
//       ...getTokenConfig().headers
//     },
//     onUploadProgress
//   };
//   try {
//     const res = await axiosBaseUrl.put(url, data, config);
//     toast.success("Updated successfully");
//     return res;
//   } catch (error) {
//     handleErrors(error);
//   }
// };
